/**
 * 搜索框交互规则（核心：仅展开/收缩两种状态）：
 * 1. 基础：展开/收缩UI交互；
 * 2. search-icon-text：展开→隐藏text、icon左移（始终显示）；收缩→text+icon都显示；
 * 3. clear-btn：仅「展开+有内容」显示，其余情况（展开无内容/收缩）均隐藏；
 * 4. expand-search-overlay：展开显示，收缩隐藏；
 */
document.addEventListener("DOMContentLoaded", function () {
  // 1. 基础元素获取
  const predictiveSearchEl = document.querySelector(
    "predictive-search.predictive-search-custom",
  );
  if (!predictiveSearchEl) return;

  const expandSearch = document.querySelector(".expand-search");
  const expandSearchInput = expandSearch?.querySelector('input[name="q"]');
  const clearBtn = document.querySelector(".clear-btn");
  const searchIconText = document.querySelector(".search-icon-text");
  const textElement = searchIconText?.querySelector(".text");
  const searchOverlay = document.querySelector(".expand-search-overlay");

  // 安全校验：所有核心元素存在才执行
  if (
    !expandSearchInput ||
    !searchIconText ||
    !searchOverlay ||
    !expandSearch ||
    !clearBtn
  )
    return;

  // 2. 核心状态管理函数
  /**
   * 更新搜索框所有交互状态
   * @param {boolean} isExpanded - 是否展开（true=展开，false=收缩）
   */
  function updateSearchUI(isExpanded) {
    const hasContent = expandSearchInput.value.trim() !== "";

    // ===== 规则1/3：展开/收缩 基础UI =====
    expandSearch.style.width = isExpanded ? "900px" : "100px";
    expandSearchInput.style.width = "100%";
    // 收缩时隐藏输入内容（视觉上），展开时显示
    expandSearchInput.classList.toggle("input-content-hidden", !isExpanded);

    // ===== 规则4/5：search-icon-text 交互 =====
    // 展开：text隐藏，icon显示且左移；收缩：text+icon都显示
    textElement.style.opacity = isExpanded ? "0" : "1";
    expandSearchInput.style.setProperty(
      "--placeholder-opacity",
      isExpanded ? "1" : "0",
    );

    // ===== 规则6/7/8/9：clear-btn 交互 =====
    // 仅 展开+有内容 显示清空按钮，其余情况隐藏
    const showClearBtn = isExpanded && hasContent;
    clearBtn.classList.toggle("show", showClearBtn);
    expandSearchInput.classList.toggle("has-content", hasContent);

    // ===== 规则10/11：expand-search-overlay 交互 =====
    // 展开显示遮罩，收缩隐藏遮罩
    searchOverlay.classList.toggle("show", isExpanded);

    // 调试日志（可删除）
    // const status = isExpanded
    //   ? hasContent
    //     ? "展开+有内容"
    //     : "展开+无内容"
    //   : hasContent
    //     ? "收缩+有内容"
    //     : "收缩+无内容";
    // console.log(`当前状态：${status}`);
  }

  // 3. 事件绑定（仅处理展开/收缩核心逻辑）
  // 3.1 聚焦 = 展开
  expandSearchInput.addEventListener("focus", function (e) {
    updateSearchUI(true);
    // 保留PredictiveSearch原生逻辑
    if (predictiveSearchEl.onFocus) predictiveSearchEl.onFocus(e);
  });

  // 3.2 失焦 = 收缩（延迟避免下拉框点击失效）
  expandSearchInput.addEventListener("blur", function (e) {
    setTimeout(() => {
      if (!predictiveSearchEl.contains(document.activeElement)) {
        updateSearchUI(false);
      }
    }, 100);
  });

  // 3.3 输入内容时更新状态（仅影响clear-btn，不改变展开/收缩）
  expandSearchInput.addEventListener("input", function (e) {
    const isExpanded = expandSearchInput.matches(":focus");
    updateSearchUI(isExpanded);
    // 保留PredictiveSearch原生逻辑
    if (predictiveSearchEl.onChange) predictiveSearchEl.onChange(e);
  });

  // 3.4 清空按钮点击事件
  clearBtn.addEventListener("click", function (e) {
    e.preventDefault();
    expandSearchInput.value = "";
    expandSearchInput.focus(); // 清空后保持展开状态
    updateSearchUI(true);
    // 保留PredictiveSearch原生逻辑
    if (predictiveSearchEl.onFormReset) predictiveSearchEl.onFormReset(e);
  });

  // 3.5 键盘事件（回车/ESC）
  expandSearchInput.addEventListener("keydown", function (e) {
    // 回车：空内容阻止提交，有内容走原生逻辑
    if (e.key === "Enter") {
      const searchValue = this.value.trim();
      if (!searchValue) {
        e.preventDefault();
        console.log("请输入搜索内容");
      } else if (predictiveSearchEl.onFormSubmit) {
        predictiveSearchEl.onFormSubmit(e);
      }
    }
    // 上下键：保留原生预测搜索逻辑
    if (e.code === "ArrowUp" || e.code === "ArrowDown") {
      if (predictiveSearchEl.onKeydown) predictiveSearchEl.onKeydown(e);
    }
  });

  // 3.6 ESC键：收缩输入框
  document.addEventListener("keyup", (e) => {
    if (
      e.code.toUpperCase() === "ESCAPE" &&
      expandSearchInput.matches(":focus")
    ) {
      expandSearchInput.blur();
      updateSearchUI(false);
    }
  });

  // 3.7 监听【浏览器窗口失去焦点】→ 处理【点击浏览器外部】
  // 无内容时，点击桌面/其他软件 → 强制失焦收缩搜索框
  window.addEventListener('blur', () => {
    const isFocused = document.activeElement === expandSearchInput;
    const isEmpty = expandSearchInput.value.trim() === '';
    if (isFocused && isEmpty) {
      expandSearchInput.blur();
      updateSearchUI(false);
    }
  });

  // 4. 初始化状态（页面加载时为收缩状态）
  updateSearchUI(false);
});

/**
 * card-with-bg组件
 * featured-common-cards组件
 * 普通卡片的文字上移交互效果
 */
document.addEventListener('DOMContentLoaded', function () {
  const initCardAnimation = () => {
    if (window.innerWidth <= 749) return;

    const commonCards = document.querySelectorAll('.card-wrapper.common-card');
    if (!commonCards) return;

    commonCards.forEach(cardEl => {
      // 关键：先清除旧事件，防止多次绑定
      cardEl.removeEventListener('mouseenter', handleCardEnter);
      cardEl.removeEventListener('mouseleave', handleCardLeave);
      
      // 绑定移入、移出
      cardEl.addEventListener('mouseenter', handleCardEnter);
      cardEl.addEventListener('mouseleave', handleCardLeave);
    });
  };
  
  // 鼠标移入：展开
  function handleCardEnter(e) {
    const currentCard = e.currentTarget; // 真正当前触发的卡片
    const desc = currentCard.querySelector('.card-des');
    if (!desc) return;

    desc.style.webkitLineClamp = 'unset';
    desc.style.overflow = 'visible';
    desc.style.display = 'block';

    desc.style.height = 'auto';
    const h = desc.offsetHeight;
    desc.style.height = 'calc(16px * 1.5 * 2)';

    desc.clientHeight; // 强制重绘

    desc.style.transition = '0.8s cubic-bezier(.22,1,.36,1)';
    desc.style.height = h + 'px';

    // 只打印当前卡片的 desc 高度
    // desc.style.height = 'auto';
    // const h = desc.offsetHeight;
    // desc.style.height = 'calc(16px * 1.5 * 2)';

    // // 强制渲染
    // desc.clientHeight; // 读取任何几何信息,均能出发强制渲染(layout reflow)

    // desc.style.transition = '0.8s cubic-bezier(.22,1,.36,1)';
    // desc.style.height = h + 'px';
  }

  // 鼠标移出：收起
  function handleCardLeave(e) {
    const currentCard = e.currentTarget;
    const desc = currentCard.querySelector('.card-des');
    if (!desc) return;

    desc.style.transition = '0.8s cubic-bezier(.22,1,.36,1)';
    desc.style.height = 'calc(16px * 1.5 * 2)';

    // 动画结束后恢复省略号样式
    setTimeout(() => {
      desc.style.webkitLineClamp = '2';
      desc.style.overflow = 'hidden';
      desc.style.display = '-webkit-box';
      desc.style.webkitBoxOrient = 'vertical';
    }, 100); // 与动画时间一致

    // 平滑收回默认两行高度
    // desc.style.transition = '0.8s cubic-bezier(.22,1,.36,1)';
    // desc.style.height = 'calc(16px * 1.5 * 2)';
  }

  // 初始化
  initCardAnimation();

  // 监听窗口大小变化（适配横竖屏切换）
  window.addEventListener('resize', initCardAnimation);
});
